import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import AllMarkdown from './allmarkdown.js';

function ArtifactSet(props) {
    const [showMarkdown, setShowMarkdown] = useState(false);
    const [selectedArtifactTitle, setSelectedArtifactTitle] = useState('');
    const [selectedMarkdown, setSelectedMarkdown] = useState('');

    const openPopUpWindow = (e) => {
        const url = e.currentTarget.dataset.url;
        const title = e.currentTarget.dataset.title;
        const details = e.currentTarget.dataset.details;
        const openInNewTab = e.currentTarget.dataset.newtab === 'true';
        if (!url && !details) return; 

        if (url) {
            if (openInNewTab) {
                window.open(url, '_blank', 'noopener,noreferrer');
            } else { 
                const screenWidth = window.screen.width;
                const screenHeight = window.screen.height;
                const popupWidth = parseInt(screenWidth * 0.8);
                const popupHeight = parseInt(screenHeight * 0.8);
                const left = parseInt((screenWidth - popupWidth) / 2);
                const top = parseInt((screenHeight - popupHeight) / 2);

                const windowFeatures = `top=${top},left=${left},width=${popupWidth},height=${popupHeight},location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,titlebar=no,toolbar=no,directories=no`;
                window.open(url, '_blank', windowFeatures);
            }
        } else {
            setSelectedArtifactTitle(title);
            setSelectedMarkdown(details);
            setShowMarkdown(true);
        } 
    };

    return (<>
        {(props.artifacts && (props.artifacts.length > 0)) ? (<>
            <div className="pt-5 artifacts pb-5 border-bottom border-secondary">
                {props.artifacts.map((row, index) => { return (
                <div key={index} style={{cursor: "pointer"}} data-id={row._id} data-title={row.Desc} data-newtab={row.OpenNewTab} data-url={row.Link} data-details={row.Details} onClick={openPopUpWindow}>
                    {(row["Layout"] && (row["Layout"] === 'Half')) ? 
                    (<>
                    <div className="artifact rounded">
                        <div className="artifact-content flex-grow-1">
                            <div className="artifact-type">{row["Artifact Type"] && row["Artifact Type"][0] && row["Artifact Type"][0].display_value}</div>
                            <div data-aos="fade-up" data-aos-delay="100">
                                <div className="mt-auto nav-link" data-aos="fade-up" data-aos-delay="100">
                                    <span className="py-1 artifact-title lato-regular">{row.Desc}</span>
                                </div>
                            </div>
                        </div>
                        <div className="mx-1 m-2 d-flex flex-column justify-content-end">
                        {props.showCapabilities && row.Capability.filter(e => e.display_value !== 'Home Page').map((item, index) => (
                            <div className="px-1 fs-6"><small>{item.display_value}</small></div>
                        ))}
                        </div>
                        <div className='artifact-bg d-flex flex-column justify-content-end' style={{backgroundImage: `url(${row['fnMediaLink']})`, height: "50%"}}>
                        </div>
                    </div>
                    </>) : (
                    <div className="artifact rounded">
                        <div className="artifact-type">{row["Artifact Type"] && row["Artifact Type"][0] && row["Artifact Type"][0].display_value}</div>
                        <div className="artifact-content artifact-bg flex-grow-1" style={{backgroundImage: `url(${row['fnMediaLink']})`}}>
                            <div className="mt-auto nav-link flex-grow-1" data-aos="fade-up" data-aos-delay="100">
                                <span className="py-1 artifact-title lato-regular"><span className="frost">{row.Desc}</span></span>
                            </div>
                            {/*
                            <div className='h-100 m-3 d-flex flex-grow-1 fs-6' data-aos="fade-right" data-aos-delay="100">
                                {row.Details ? (<AllMarkdown>{row.Details}</AllMarkdown>) : ''}
                            </div>
                            */}
                            <div className="mx-1 mb-2 gloss rounded d-flex flex-column justify-content-end justify-self-end">
                            {props.showCapabilities && row.Capability.filter(e => e.display_value !== 'Home Page').map((item, index) => (
                                <div className="px-1 fs-6"><small>{item.display_value}</small></div>
                            ))}
                            </div>
                        </div>
                    </div>
                    )}
                </div>
                )})}
            </div>
        </>) : ''}
        <Modal size="xl" show={showMarkdown} onHide={() => setShowMarkdown(false)} centered style={{zIndex: "99999"}}>
            <Modal.Header closeButton>
            <div className="d-flex flex-row">
                <img className="my-auto" src="/favicon-16x16.png" alt="Allteam" />
                <div className="mx-2 my-auto" style={{textTransform: 'uppercase', letterSpacing: '0.1rem'}}>{selectedArtifactTitle}</div>
            </div>
            </Modal.Header>
            <Modal.Body>
            <AllMarkdown>{selectedMarkdown}</AllMarkdown>
            </Modal.Body>
        </Modal>
    </>)
}

export default ArtifactSet;